import { FC, MouseEvent, useEffect, useState } from 'react';
import { Button, ButtonProps, MenuItem } from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import { CSVLink } from 'react-csv';

import {
    ATTRIBUTION_EXPORT_METHOD_DOWNLOAD,
    ATTRIBUTION_EXPORT_METHOD_EMAIL,
    // ATTRIBUTION_EXPORT_TYPE_CSV,
    ATTRIBUTION_EXPORT_TYPE_PDF,
    AttributionExport,
} from '../../../../types/AttributionExport';

import { useHatCsvExporter } from '../../../../hooks/Exporters/HatCsvExporter';
import { useHatExport } from '../../../../hooks/Exports/HatExport';
import { useAttributionPageContext } from '../../../../hooks/useAttributionPage';
import HatExportDialog from './HatExportDialog';
import Menu from '../../../../components/Menu';

const HatExportMenuButton: FC<ButtonProps> = (props): React.JSX.Element => {
    const csvExporter = useHatCsvExporter();

    const { attributionType, dealer, attributionDate } = useAttributionPageContext();
    const { generateExportFilename } = useHatExport();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [attributionExport, setAttributionExport] = useState<AttributionExport>({
        exportMethod: ATTRIBUTION_EXPORT_METHOD_DOWNLOAD,
        exportType: ATTRIBUTION_EXPORT_TYPE_PDF,

        dealerId: dealer ? dealer.id : 0,
        attributionDate: attributionDate,
        attributionType: attributionType,
    });
    const [exportDialogOpen, setExportDialogOpen] = useState<boolean>(false);

    const [filename, setFilename] = useState<string>('');

    useEffect(() => {
        const fetchFilename = async () => {
            const name = await generateExportFilename('{id}.csv');
            setFilename(name);
        };

        fetchFilename();
    }, [generateExportFilename]);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const getCsvData = () => {
        let rows = [];

        rows = csvExporter.getCsvData();

        return rows;
    };

    return (
        <div>
            <Button
                id="hat-export-menu-button"
                aria-controls={open ? 'hat-export-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="outlined"
                disableElevation
                onClick={handleClick}
                endIcon={<ArrowDropDownIcon />}
                size="medium"
                {...props}
            >
                Export
            </Button>
            <Menu
                id="hat-export-menu"
                MenuListProps={{
                    'aria-labelledby': 'hat-export-menu-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ width: 300 }}
            >
                <MenuItem
                    disableRipple
                    onClick={() => {
                        setAttributionExport({
                            ...attributionExport,
                            exportMethod: ATTRIBUTION_EXPORT_METHOD_DOWNLOAD,
                            exportType: ATTRIBUTION_EXPORT_TYPE_PDF,
                        });
                        setExportDialogOpen(true);
                    }}
                >
                    PDF
                </MenuItem>
                <MenuItem disableRipple>
                    <CSVLink
                        data={getCsvData()}
                        filename={filename}
                        style={{
                            display: 'inline-block',
                            width: '100%',
                            textDecoration: 'none',
                        }}
                    >
                        CSV
                    </CSVLink>
                </MenuItem>
                <MenuItem
                    disableRipple
                    onClick={() => {
                        setAttributionExport({
                            ...attributionExport,
                            exportMethod: ATTRIBUTION_EXPORT_METHOD_EMAIL,
                            exportType: ATTRIBUTION_EXPORT_TYPE_PDF,
                        });
                        setExportDialogOpen(true);
                    }}
                >
                    Email
                </MenuItem>
            </Menu>

            <HatExportDialog
                open={exportDialogOpen}
                onClose={() => {
                    setExportDialogOpen(false);
                }}
                attributionExport={attributionExport}
            />
        </div>
    );
};

export default HatExportMenuButton;
